import { Quote } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal } from "./Reveal";

export default function Quotes() {
  const { t } = useLang();

  return (
    <section id="citazioni" data-testid="quotes-section" className="relative overflow-hidden bg-[#0F172A] py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 left-1/4 h-96 w-96 rounded-full bg-sky-500/20 blur-[130px]" />
        <div className="absolute bottom-0 right-1/4 h-80 w-80 rounded-full bg-amber-400/10 blur-[120px]" />
        <div className="absolute inset-0 bg-grid-dark opacity-30" />
      </div>

      <div className="relative mx-auto max-w-4xl px-5 sm:px-8 text-center">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-sky-300">{t.quotes.lead}</p>
          <Quote size={30} className="mx-auto mt-6 text-amber-400" />
          <blockquote className="mt-6 font-serif-accent italic text-2xl sm:text-4xl leading-snug text-white">
            {t.quotes.q1}
          </blockquote>
          <p className="mt-6 font-mono text-sm font-bold uppercase tracking-[0.2em] text-amber-400" data-testid="quote-author-abacico">
            - {t.quotes.a1} -
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-16">
          <p className="text-sm text-slate-400">{t.quotes.q2Lead}</p>
          <blockquote className="mt-4 font-display text-3xl sm:text-5xl font-bold tracking-tight text-white" data-testid="quote-text-jobs">
            {t.quotes.q2}
          </blockquote>
          <p className="mt-4 font-mono text-sm font-bold uppercase tracking-[0.2em] text-sky-400" data-testid="quote-author-jobs">
            -{t.quotes.a2} -
          </p>
        </Reveal>
      </div>
    </section>
  );
}
